import React, { Component } from 'react';
import '../assets/styles/Footer.sass';

class Footer extends Component {
  render() {
    return(
      <footer className="Footer">
        Copyright &#169; Marina Ferreira
      </footer>
    );
  }
}

export default Footer;
